import { SelectItem } from 'primeng/api';
import { ENV_URLS } from 'src/environments/environment';
import { UserTypeData } from '../models/User';
import { WEBSITE_URLS } from '../shared/global';
export const SIGNATURE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const CONSULTATION_NOTES = 10000;

export const CONSULTATION_REASON = 1000;

const blockSpecial: RegExp = /^[^<>*!]+$/;

const alpbhetsWithSpace: RegExp = /^[a-zA-Z ]+$/;

const number = /[0-9]+/;

const only_number: RegExp = /^[0-9]+$/;

const alphaNumericWithSpace: RegExp = /^[a-zA-Z0-9^\s]+$/;

const alphaNumericWithSpaceAndDecimal: RegExp = /^[a-zA-Z0-9.^\s]+$/;

const alphaNumericSpecialCharactersWithSpace: RegExp = /^[a-zA-Z0-9 &._-]+/;

const floatOrDecimalNumber: RegExp = /^\d+(\.\d+)?$/;

// const floatOrDecimalNumber: RegExp = /\d*(\.\d+)?$/;

export const name_input: RegExp = alpbhetsWithSpace;

export const medical_degree: RegExp = alpbhetsWithSpace;

export const address: RegExp = blockSpecial;

export const city: RegExp = alpbhetsWithSpace;

export const zipCode: RegExp = alphaNumericWithSpace;

export const buesinessIdentification: RegExp = alphaNumericWithSpace;

export const phoneNumber: RegExp = only_number;

export const number_input: RegExp = only_number;

export const float_number: RegExp = floatOrDecimalNumber;

export const textareaBox: RegExp = blockSpecial;

export const medication_name_input: RegExp =
    alphaNumericSpecialCharactersWithSpace;

export const dose_input: RegExp = alphaNumericWithSpaceAndDecimal;

export const blockSpecialCharachters: RegExp = blockSpecial;

export const occupation_name_input: RegExp = alpbhetsWithSpace;

export const SALUTATIONS = [
    'Dr.',
    'Mr.',
    'Mrs.',
    'Asst. Professor',
    'Professor',
    'Miss.'
];

export const APPOINTMENT_STATUS = [
    'Scheduled',
    'Closed',
    'Rescheduled',
    'Reassigned',
    'Open'
];

export const GOOGLE_RECAPTCHA_SITE_KEY =
    '6LdMV7QaAAAAAKrEZuItsHKpUXQJAdSunAHzEKsc';

export const recaptcha_invisible = {
    siteKey: '6LeyYh8oAAAAAN5onRHZLNXh8s7P0AiGW-i3SPAy',
}

export const FORM_LINK = ENV_URLS.COVID_19_FORM;

// export const NEWS_DATA_JSON_LINK="https://eglobalblobdev.blob.core.windows.net/assets/news/NewsData.json";

export const DOCTOR_REGISTRATION_FORM = 'https://youtu.be/RXvWySbpVTc';
export const DOCTOR_KOBO_FORM =
    'https://kf.form.eglobaldoctors.com/accounts/login/?next=/#/';
export const SPECIAL_FORM_LINK = ENV_URLS.FREE_COUNSELING_FORM;
export const OTHER_MEDICAL_OCCUPATIONS = [
    'Nurse Practitioner',
    'Physician Assistant',
    'Nurse',
    'Physical Therapist',
    'Occupational Therapist',
    'Respiratory Therapist',
    'Nutritionist',
    'Others'
];


export const PROFILES_TYPE: SelectItem[] = [
    { value: 0, label: 'Doctor' },
    { value: 1, label: 'Other Medical Professionals' }
];

export const IMAGE_PROFILE_ID_SUPPORTED_TYPES = [
    'image/jpeg',
    'image/png',
    'image/jpg'
];

export const RESUME_SUPPORTED_TYPES = ['application/pdf'];

export const DOCUMENT_SUPPORTED_TYPES = [
    'image/jpeg',
    'image/png',
    'image/jpg',
    'application/pdf',
    'application/dicom'
];

export const EGLOBAL_LOGO =
    'https://eglobalblobdev.blob.core.windows.net/assets/logo/logo2.png';

export const DEFUALT_DOCTOR_IMAGE =
    './assets/images/defualts/default_doc_profile.jpg';

export const USER_TYPES = {
    PATIENT: 'patient',
    DOCTOR: 'doctor',
    'OTHER-MEDICAL-PROFESSIONALS': 'other-medical-professionals',
    'SUPPORT': 'support',
    'VENDOR': 'vendor'
};

export const USER_TYPE_DATA: UserTypeData[] = [
    {
        user_type: USER_TYPES['PATIENT'],
        text_data: `You have successfully registered.`
    },
    {
        user_type: USER_TYPES['DOCTOR'],
        text_data: `Successfully registered.\n Please allow us to review your profile.\n You will receive an automated email once your profile is approved.`
    },
    {
        user_type: USER_TYPES['OTHER-MEDICAL-PROFESSIONALS'],
        text_data: `Successfully registered.\n Please allow us to review your profile.\n You will receive an automated email once your profile is approved.`
    },
    {
        user_type: USER_TYPES['SUPPORT'],
        text_data: `You have successfully registered.`
    },
    {
        user_type: USER_TYPES['VENDOR'],
        text_data: `You have successfully registered.`
    }
];

export const URLS: WEBSITE_URLS = {
    API_BASE_URL: ENV_URLS.API_BASE_URL,
    BLOGS_BASE_URL: ENV_URLS.BLOGS_BASE_URL,
    HOMPAGE_BASE_URL: ENV_URLS.HOMPAGE_BASE_URL,
    PORTAL_BASE_URL: ENV_URLS.PORTAL_BASE_URL,
    FREE_COUNSELING_FORM: ENV_URLS.FREE_COUNSELING_FORM,
    COVID_19_FORM: ENV_URLS.COVID_19_FORM,
    IS_UK: ENV_URLS.IS_UK
}

export enum ROLES {
    'Patient' = 0,
    'Doctor' = 1,
    'Admin' = 2,
    'SuperAdmin' = 3,
    'SuperAdmin_Doctor' = 4,
    'Admin_Doctor' = 5,
    'Other_Medical_Professional' = 6,
    'Other_Medical_Professional_Admin' = 7,
    'Support' = 8,
    'Vendor' = 9
}

export const DOCTOR_ROLES = [
    ROLES.Doctor,
    ROLES.Admin,
    ROLES.SuperAdmin,
    ROLES.SuperAdmin_Doctor,
    ROLES.Admin_Doctor,
];

export const PATIENT_ROLES = [ROLES.Patient];
export const SUPPORT_ROLES = [ROLES.Support];
export const VENDOR_ROLES = [ROLES.Vendor];
export const OTHER_MEDICAL_PROFESSIONAL_ROLES = [
    ROLES.Other_Medical_Professional,
    ROLES.Other_Medical_Professional_Admin,
];

export const sentry_dsn =
    'https://69801c09c68c439d8c8407e0cd011816@o1064556.ingest.sentry.io/6143112';

export enum roles {
    patient = 'patient',
    doctor = 'doctor',
    support = 'support',
    vendor = 'vendor'
}

export const MEDICAL_CONDITION_DESCRIPTION: number = 500;
export const DIET_HEALTH_GOAL: number = 500;
export const DIET_FOOD_DESC: number = 500;
export const DIET_FOOD_DESC_PLACEHOLDER: string =
    'Poha (100gms) \n Banana (1unit)';

export enum CONSULTATION_TYPES {
    PRIMARY_MEDICAL_CONSULTATION = 2,
    EXPERT_SECOND_MEDICAL_CONSULTATION = 1,
    MULTI_SPECIALTY_CONSULTATION = 4,
    FOLLOW_UP_CONSULTATION = 3,
    NUTRITION_AND_HEALTH_CONSULTATION = 5
}

export const STORAGE_ASSETS_LINK =
    'https://eglobalblobdev.blob.core.windows.net/assets/';


export enum ProviderService {
    STRIPE = "STRIPE",
    RAZORPAY = "RAZORPAY",
    TWILIO = "TWILIO",
    EMAIL = "EMAIL",
    FIREBASE = "FIREBASE"
}
